<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Raise Complaint'
                    : 'Deleted Raise Complaint'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/raise-complaints/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Store</th>
                      <th class="text-left" style="min-width: none">User</th>
                      <th class="text-left" style="min-width: none">
                        Category
                      </th>
                      <th class="text-left" style="min-width: none">
                        Description
                      </th>
                      <th class="text-left" style="min-width: none">
                        Documents
                      </th>
                      <th class="text-left" style="min-width: none">Remarks</th>
                      <th class="text-right action_th" style="min-width: 250px; width: 250px;">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="raise_complaints.length != 0">
                    <tr
                      v-for="(raise_complaint, i) in raise_complaints"
                      :key="`raise_complaint_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': raise_complaints.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="raise_complaint.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Raise Complaint is Pending</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="raise_complaint.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Raise Complaint is Approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="raise_complaint.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Raise Complaint is Rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ raise_complaint.store?.store_location || "" }}
                      </td>
                      <td>
                        {{ raise_complaint.user ? raise_complaint.user.first_name : "N/A" }}
                      </td>
                      <td>
                        <span v-if="raise_complaint.complaint_type" class="text-body-2">
                          {{ raise_complaint.complaint_type.description }}
                        </span>
                        <v-chip v-else small outlined color="orange" text-color="orange darken-1">
                          No type set
                        </v-chip>
                      </td>
                      <td>
                        {{ raise_complaint.description || "" }}
                      </td>
                      <td>
                        <div v-if="raise_complaint.documents && raise_complaint.documents.length > 0" class="d-flex flex-wrap">
                          <v-tooltip 
                            bottom 
                            v-for="(document, index) in raise_complaint.documents" 
                            :key="index"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                small
                                icon
                                :href="mediaUrl + document.doc_path"
                                color="primary"
                                target="_blank"
                                class="ma-1"
                              >
                                <v-icon>{{ getDocumentIcon(document.doc_path) }}</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ getDocumentName(document, index) }}</span>
                          </v-tooltip>
                        </div>
                        <div v-else class="text-center">
                          <v-chip small outlined>No documents</v-chip>
                        </div>
                      </td>
                      <td>
                        <span v-if="raise_complaint.remarks" class="text-body-2">
                          {{ raise_complaint.remarks }}
                        </span>
                        <v-chip v-else small outlined color="grey" text-color="grey darken-1">
                          No remarks
                        </v-chip>
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom v-if="raise_complaint.user">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                class="my-auto"
                                color="primary"
                                x-large
                                :to="`/users/${encryptIt(raise_complaint.user.id)}`"
                              >
                                <v-icon dark> mdi-account-edit </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit User</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                class="my-auto"
                                color="success"
                                x-large
                                :disabled="raise_complaint.status != 0"
                                @click="handleStatus(raise_complaint, 1)"
                              >
                                <v-icon dark> mdi-check-circle-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>Approve</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                class="mx-1"
                                color="red"
                                x-large
                                :disabled="raise_complaint.status != 0"
                                @click="handleStatus(raise_complaint, 2)"
                              >
                                <v-icon dark> mdi-close-circle-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>Reject this Complaint</span>
                          </v-tooltip>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(raise_complaint.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Complaint</span>
                          </v-tooltip> -->
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(raise_complaint.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this raise_complaint</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_raise_complaint" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Raise Complaint deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_raise_complaint = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_raise_complaint" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Raise Complaint restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_raise_complaint = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Confirmation Dialog Component -->
      <ConfirmationDialog
        :show.sync="dialog"
        :title="dialogTitle"
        :message="dialogMessage"
        :icon="dialogIcon"
        :color="dialogColor"
        :isRejection="isRejection"
        @confirm="confirmApproval"
      />
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  name: "RaiseComplaintPage",
  data() {
    return {
      filter: {
        is_active: "",
        search_keyword: "",
        show_deleted: false,
      },
      raise_complaints: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportRaiseComplaintTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_raise_complaint: false,
      is_deleted_raise_complaint: false,
      is_restored_raise_complaint: false,

      selectedDataId: null,
      dialog: false,
      dialogTitle: "",
      dialogMessage: "",
      dialogIcon: "",
      dialogColor: "",
      selectedComplaintId: "",
      selectedComplaintStatus: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.is_active = this.filter.is_active || "";

      let query = new URLSearchParams({
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        ...this.filter,
      });

      await axios
        .get(`raise_complaints?${query}`)
        .then((response) => {
          this.raise_complaints = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`raise_complaint_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async restoreData(id) {
      this.restore_raise_complaint = true;
      await axios
        .post(`/raise_complaints/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_raise_complaint = false;
          this.is_restored_raise_complaint = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async deleteData(id) {
      await axios
        .post(`/raise_complaints/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },

    handleStatus(order, status) {
      const isApproval = status === 1;
      this.dialogTitle = isApproval ? "Approved" : "Reject";

      this.dialogMessage = isApproval
        ? "Are you sure you want to approve this Complaint?"
        : "Are you sure you want to reject this Complaint?";

      this.dialogIcon = isApproval
        ? "mdi-check-circle-outline"
        : "mdi-alert-circle-outline";

      this.dialogColor = isApproval ? "green" : "red";

      this.selectedComplaintId = order.id;
      this.selectedComplaintStatus = status;
      this.isRejection = !isApproval;
      this.dialog = true; // Open dialog
    },
    async confirmApproval(rejectionReason) {
      const payload = {
        status: this.selectedComplaintStatus,
        remarks: this.selectedComplaintStatus === 2 ? rejectionReason : null,
      };
      await axios
        .patch(
          `/raise_complaints/${this.encryptIt(this.selectedComplaintId)}`,
          payload
        )
        .then(() => {
          this.getData();
          if (this.selectedComplaintStatus == 1) {
            this.$toast.success("Complaint is approved successfully!", {
              position: "top-right",
              timeout: 3000,
            });
          } else {
            this.$toast.error("Complaint is rejected!", {
              position: "top-right",
              timeout: 3000,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });

      this.selectedComplaintId = "";
      this.selectedComplaintStatus = "";
    },
    
    getDocumentIcon(filePath) {
      const extension = filePath.split('.').pop().toLowerCase();
      
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
        return 'mdi-file-image';
      } else if (extension === 'pdf') {
        return 'mdi-file-pdf-box';
      } else if (['doc', 'docx'].includes(extension)) {
        return 'mdi-file-word';
      }
      return 'mdi-file-document';
    },
    
    getDocumentName(document, index) {
      return document.original_filename || `Document ${index + 1}`;
    },
  },
};
</script>
